import React from 'react'
import Carousel from 'react-bootstrap/Carousel';

const SliderHome = () => {
  return (
    <Carousel fade>
      <Carousel.Item>
        <img
        
          className="d-block w-100"
          src="https://i.postimg.cc/wqSPTCjr/DSC-7764.jpg/800x400?text=First slide&bg=373940"
          alt="First slide"
        />
        <Carousel.Caption style={{ color: 'greenyellow' }}>

          <p>HOD OF SB Pathshala</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/25jbskJB/DSC-7384.jpg/800x400?text=Second slide&bg=282c34"
          alt="Second slide"
        />

      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/4x8GLXTd/DSC-7938.jpg/800x400?text=Third slide&bg=20232a"
          alt="Third slide"
        />


      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/QNk68R7j/DSC-2728.jpg/800x400?text=Fourth slide&bg=20232a"
          alt="Fourth slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/pXZTJSvf/Whats-App-Image-2023-12-15-at-7-38-40-PM.jpg"
          alt="Fifth slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/bvHD4vc5/Whats-App-Image-2023-12-15-at-7-38-40-PM-1.jpg"
          alt="six slide"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://i.postimg.cc/v81qwRTz/Whats-App-Image-2023-12-15-at-7-38-41-PM.jpg"
          alt="six slide"
        />
      </Carousel.Item>
    </Carousel>
  )
}

export default SliderHome




